import { withJsonFormsControlProps } from '@jsonforms/react';
import { MaterialInputControl, MuiInputText } from '@jsonforms/material-renderers';

const CustomLabelTextControl = (props: any) => {
  const fieldName = props.path?.split('.').pop();

  const itemSchema = props.rootSchema?.properties?.messages?.items;

  const isCustomRequired = itemSchema?.customRequired?.includes(fieldName);

  let customErrors = props.errors.trim() ? [props.errors] : [];

  if (isCustomRequired) {
    if (!props.data || props.data.trim() === '') {
      const hasRequiredError = customErrors.some(
        (error: any) => error.keyword === 'required' || error.message?.includes('required')
      );

      if (!hasRequiredError) {
        customErrors = [...customErrors, `is a required property`];
      }
    }
  } else {
    customErrors = customErrors.filter(
      (error: any) => !(error.keyword === 'required' || error.message?.includes('required'))
    );
  }

  const isVisible = props.visible;
  if (!isVisible) return null;

  // console.log({ isCustomRequired, fieldName, customErrors, props }, 'CustomLabelTextControl');

  return (
    <MaterialInputControl
      {...props}
      input={MuiInputText}
      errors={isVisible ? customErrors : []}
      required={isVisible && isCustomRequired}
    />
  );
};

export default withJsonFormsControlProps(CustomLabelTextControl);
